import { createContext } from "react";

import { DemandPlanVariant } from "@models/DemandPlanVariant";

type Editor<R> = {
  readonly current: R | null;
  next: () => void;
  previous: () => void;
  start: (rec: R) => void;
  complete: (rec: R) => void;
  canEdit: (rec: R) => boolean;
};

export const EditingContext = createContext<Editor<DemandPlanVariant>>(
  {} as any
);
